import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { CreateStaticSiteFormValues } from '@/routes/static-sites/create-static-site/form/schema'

export const Name = () => {
  const form = useFormContext<CreateStaticSiteFormValues>()
  const { resetField } = form

  useEffect(() => {
    return () => {
      resetField('displayName')
    }
  }, [resetField])

  return (
    <FormField
      control={form.control}
      name="displayName"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Name</FormLabel>
          <FormControl>
            <Input
              autoComplete="off"
              placeholder="My static site name"
              aria-label="Static site name"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
